import './AppointmentRibbonInfoBlock.scss'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo } from 'react'
import AppointmentRibbonInfoItem from '../../DetailsView/AppointmentRibbonInfoItem/AppointmentRibbonInfoItem'
import {
  APPOINTMENT_ADDITIONAL_INFO_VISIT_OPTION,
  APPOINTMENT_ADDITIONAL_PATIENT_ADDRESS_OPTION,
  APPOINTMENT_ADDITIONAL_VISIT_STATUS_OPTION,
  APPOINTMENT_INFO_ID_CONSTANT_PART,
  APPOINTMENT_ADDITIONAL_INFO_EMAIL_OPTION,
} from '../../../../utils/constants'
import {
  getVisitMethodOptionFromVisitMethod,
  VisitMethods,
} from '../../../new-visit/components/visit-information/VisitMethods'

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const AppointmentRibbonInfoBlock = memo(({ dataList, title }) => {
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const isWithoutCapitalize = (option) =>
    option?.name === APPOINTMENT_ADDITIONAL_INFO_VISIT_OPTION ||
    option?.name === APPOINTMENT_ADDITIONAL_PATIENT_ADDRESS_OPTION ||
    option?.name === APPOINTMENT_ADDITIONAL_INFO_EMAIL_OPTION ||
    option?.name === APPOINTMENT_ADDITIONAL_VISIT_STATUS_OPTION

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const isVisitMethodValue = (value) => Object.values(VisitMethods).includes(value)

  return (
    <div className='common-appointment-info-ribbon-container'>
      <div className='appointment-info-ribbon-title'>{title}</div>
      {/*
       // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
      {dataList?.map((optionInfo) => {
        return (
          <AppointmentRibbonInfoItem
            key={optionInfo.name}
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            id={APPOINTMENT_INFO_ID_CONSTANT_PART + optionInfo.name}
            isWithBorderBottom={optionInfo.name !== dataList[dataList.length - 1].name}
            isWithoutCapitalize={isWithoutCapitalize(optionInfo)}
            itemName={optionInfo.name}
            itemValue={
              isVisitMethodValue(optionInfo.value) ?
                getVisitMethodOptionFromVisitMethod(optionInfo.value)
              : optionInfo.value
            }
          />
        )
      })}
    </div>
  )
})

export default AppointmentRibbonInfoBlock
